import { action, extend, types } from "@gadgetinc/mobx-quick-tree";
import { NominalContractSnapshot, ServerContract } from "../../ServerContract";
import type { ProblemsList } from "../../problems/ProblemsList";
import { ShopifyAdminAppConfigProblems } from "../../problems/finders/ShopifyAdminAppConfigProblems";
import { ShopifyBaseAppConfig } from "./ShopifyBaseAppConfig";

/**
 * See packages/state-trees/src/connections/ShopifyConnectionConfig.ts for documentation
 * on the different types of Shopify configurations
 */
export const ShopifyBaseAdminAppConfig = <Name extends string>(name: Name) => {
  class BasicAdminAppConfig extends extend(ShopifyBaseAppConfig(name), {
    shopDomain: types.string,
    accessToken: types.string,
    serverContract: types.optional(ServerContract, NominalContractSnapshot),
  }) {
    get problems(): ProblemsList {
      return ShopifyAdminAppConfigProblems(this as any);
    }
    @action
    setShopDomain(value: string) {
      this.shopDomain = value;
    }
    @action
    setAccessToken(value: string) {
      this.accessToken = value;
    }
    @action
    clearAccessToken() {
      this.accessToken = "";
    }
  }
  return BasicAdminAppConfig;
};
